import { listServices } from "./service";

export const serviceQueryKeys = {
  all: ["provider", "admin", "services"] as const,
  lists: () => [...serviceQueryKeys.all, "list"] as const,
  list: (params?: { includeArchived?: boolean }) =>
    params?.includeArchived
      ? ([...serviceQueryKeys.lists(), { includeArchived: true }] as const)
      : ([...serviceQueryKeys.lists()] as const),
  detail: (serviceId: string) =>
    [...serviceQueryKeys.all, "detail", serviceId] as const,
};

export const serviceQueryOptions = {
  list: (params?: { includeArchived?: boolean }) => ({
    queryKey: serviceQueryKeys.list(params),
    queryFn: () => listServices(params),
  }),
  detail: (serviceId: string) => ({
    queryKey: serviceQueryKeys.detail(serviceId),
    queryFn: () =>
      listServices({ ids: [serviceId] }).then(
        (services) => services[0] ?? null,
      ),
  }),
};
